(function () {
    const SECTION_SELECTOR = '.video-scroll';
    const VIDEO_SELECTOR = 'video';
    const CONTENT_SELECTOR = '.video-scroll-content';
    const WRAPPER_SELECTOR = '.video-scroll-content-wrapper';
    const ITEM_SELECTOR = '.video-scroll-item';
    const MOBILE_BREAKPOINT = 991.98;

    /*
     * Zusätzlicher Scrollweg, während das letzte Item
     * sichtbar in der Mitte stehen bleibt.
     */
    const END_HOLD_SCROLL_DISTANCE = 450;

    let section;
    let video;
    let content;
    let wrapper;
    let items = [];

    let viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

    /*
     * Tatsächlicher virtueller Scrollwert inklusive
     * des zusätzlichen Scrollwegs am Ende.
     */
    let virtualScroll = 0;

    /*
     * Maximale Position, an der das letzte Item
     * mittig im sichtbaren Bereich steht.
     */
    let contentMaxVirtualScroll = 0;

    /*
     * Gesamter virtueller Scrollweg inklusive
     * der zusätzlichen Haltephase.
     */
    let maxVirtualScroll = 0;

    let contentHeight = 0;
    let itemsMeta = [];

    let locked = false;
    let touchStartY = null;
    let sceneState = 'idle';

    let intersectionObserver = null;
    let fallbackScrollHandler = null;

    let lastScrollY =
        window.scrollY ||
        window.pageYOffset ||
        0;

    let scrollDirection = 'down';

    function isMobile() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function init() {
        section = document.querySelector(SECTION_SELECTOR);

        if (!section) {
            return;
        }

        video = section.querySelector(VIDEO_SELECTOR);
        content = section.querySelector(CONTENT_SELECTOR);
        wrapper = section.querySelector(WRAPPER_SELECTOR);

        items = Array.from(
            section.querySelectorAll(ITEM_SELECTOR)
        );

        if (!video) {
            return;
        }

        setupVideoBase();

        if (isMobile()) {
            setupMobileMode();
        } else {
            if (!content || !wrapper || items.length === 0) {
                return;
            }

            setupDesktopMode();
        }

        window.addEventListener('resize', onResize);
    }

    function setupVideoBase() {
        video.muted = true;
        video.playsInline = true;
    }

    function setupMobileMode() {
        destroyDesktopMode();

        if (content) {
            content.style.display = 'none';
        }

        if (wrapper) {
            wrapper.style.transform = '';
            wrapper.style.paddingTop = '';
            wrapper.style.paddingBottom = '';
        }

        items.forEach((item) => {
            item.style.opacity = '';
        });

        playVideo();

        video.autoplay = true;
        video.loop = true;
        video.controls = false;

        const tryPlay = function () {
            const playPromise = video.play();

            if (
                playPromise &&
                typeof playPromise.catch === 'function'
            ) {
                playPromise.catch(function () {});
            }
        };

        tryPlay();

        video.addEventListener(
            'canplay',
            tryPlay,
            { once: true }
        );
    }

    function setupDesktopMode() {
        if (content) {
            content.style.display = '';
        }

        setupVideoAutoplay();
        recalcLayout();
        updateLayout();

        window.addEventListener(
            'scroll',
            onWindowScroll,
            { passive: true }
        );
    }

    function destroyDesktopMode() {
        unlockScrollCleanup();

        window.removeEventListener(
            'scroll',
            onWindowScroll
        );

        if (intersectionObserver) {
            intersectionObserver.disconnect();
            intersectionObserver = null;
        }

        if (fallbackScrollHandler) {
            window.removeEventListener(
                'scroll',
                fallbackScrollHandler
            );

            fallbackScrollHandler = null;
        }

        sceneState = 'idle';
        touchStartY = null;
    }

    function onResize() {
        viewportHeight =
            window.innerHeight ||
            document.documentElement.clientHeight;

        if (isMobile()) {
            setupMobileMode();
        } else {
            if (!content || !wrapper || items.length === 0) {
                return;
            }

            destroyDesktopMode();
            setupDesktopMode();
        }
    }

    function recalcLayout() {
        wrapper.style.transform = 'translateY(0)';

        const contentRect = content.getBoundingClientRect();

        contentHeight = contentRect.height;

        /*
         * Das obere Padding sorgt dafür, dass das erste Item
         * von unten in den sichtbaren Bereich scrollt.
         */
        wrapper.style.paddingTop = contentHeight + 'px';

        /*
         * Das untere Padding bleibt bestehen, wird aber nicht
         * mehr für die finale Scrollposition verwendet.
         */
        wrapper.style.paddingBottom = contentHeight + 'px';

        itemsMeta = items.map(function (element) {
            return {
                el: element,
                top: element.offsetTop,
                height: element.offsetHeight
            };
        });

        const lastItemMeta =
            itemsMeta[itemsMeta.length - 1];

        if (lastItemMeta) {
            /*
             * Diese Position setzt die Mitte des letzten Items
             * exakt in die Mitte des sichtbaren Bereichs.
             */
            contentMaxVirtualScroll = Math.max(
                0,
                lastItemMeta.top +
                lastItemMeta.height / 2 -
                contentHeight / 2
            );
        } else {
            contentMaxVirtualScroll = 0;
        }

        /*
         * Nach Erreichen des letzten Items muss noch diese
         * Strecke gescrollt werden, bevor entsperrt wird.
         */
        maxVirtualScroll =
            contentMaxVirtualScroll +
            END_HOLD_SCROLL_DISTANCE;

        virtualScroll = Math.max(
            0,
            Math.min(virtualScroll, maxVirtualScroll)
        );
    }

    function setupVideoAutoplay() {
        if ('IntersectionObserver' in window) {
            intersectionObserver =
                new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                playVideo();
                            } else {
                                pauseVideo();
                            }
                        });
                    },
                    {
                        threshold: 0.3
                    }
                );

            intersectionObserver.observe(section);
        } else {
            fallbackScrollHandler = function () {
                const rect =
                    section.getBoundingClientRect();

                if (
                    rect.bottom > 0 &&
                    rect.top < viewportHeight
                ) {
                    playVideo();
                } else {
                    pauseVideo();
                }
            };

            window.addEventListener(
                'scroll',
                fallbackScrollHandler,
                { passive: true }
            );
        }
    }

    function playVideo() {
        if (!video) {
            return;
        }

        if (video.paused) {
            const playPromise = video.play();

            if (
                playPromise &&
                typeof playPromise.catch === 'function'
            ) {
                playPromise.catch(function () {});
            }
        }
    }

    function pauseVideo() {
        if (!video || isMobile()) {
            return;
        }

        if (!video.paused) {
            video.pause();
        }
    }

    function detectScrollDirection() {
        const currentScrollY =
            window.scrollY ||
            window.pageYOffset ||
            0;

        if (currentScrollY > lastScrollY) {
            scrollDirection = 'down';
        } else if (currentScrollY < lastScrollY) {
            scrollDirection = 'up';
        }

        lastScrollY = currentScrollY;
    }

    function onWindowScroll() {
        if (isMobile()) {
            return;
        }

        if (locked) {
            return;
        }

        detectScrollDirection();

        const rect =
            section.getBoundingClientRect();

        const inScene =
            rect.top <= 0 &&
            rect.bottom > 0;

        if (!inScene) {
            sceneState = 'idle';
            return;
        }

        if (sceneState !== 'idle') {
            return;
        }

        if (maxVirtualScroll <= 0) {
            return;
        }

        lockScroll();
        sceneState = 'active';

        if (scrollDirection === 'down') {
            virtualScroll = 0;

            updateLayout();

            window.scrollTo({
                top: section.offsetTop,
                behavior: 'auto'
            });
        } else {
            /*
             * Beim Eintritt von unten wird direkt das letzte
             * Item angezeigt.
             */
            virtualScroll = maxVirtualScroll;

            updateLayout();

            window.scrollTo({
                top: section.offsetTop,
                behavior: 'auto'
            });
        }
    }

    function lockScroll() {
        if (locked || isMobile()) {
            return;
        }

        locked = true;

        document.body.classList.add(
            'video-scroll-locked'
        );

        window.addEventListener(
            'wheel',
            onWheel,
            { passive: false }
        );

        window.addEventListener(
            'touchstart',
            onTouchStart,
            { passive: false }
        );

        window.addEventListener(
            'touchmove',
            onTouchMove,
            { passive: false }
        );

        window.addEventListener(
            'touchend',
            onTouchEnd,
            { passive: false }
        );
    }

    function unlockScroll(direction) {
        if (!locked) {
            return;
        }

        unlockScrollCleanup();

        if (direction === 'down') {
            sceneState = 'finishedDown';

            window.scrollTo({
                top:
                    section.offsetTop +
                    section.offsetHeight,
                behavior: 'auto'
            });
        } else if (direction === 'up') {
            sceneState = 'finishedUp';

            window.scrollTo({
                top: section.offsetTop - 1,
                behavior: 'auto'
            });
        }
    }

    function unlockScrollCleanup() {
        locked = false;

        document.body.classList.remove(
            'video-scroll-locked'
        );

        window.removeEventListener(
            'wheel',
            onWheel
        );

        window.removeEventListener(
            'touchstart',
            onTouchStart
        );

        window.removeEventListener(
            'touchmove',
            onTouchMove
        );

        window.removeEventListener(
            'touchend',
            onTouchEnd
        );
    }

    function onWheel(event) {
        if (isMobile()) {
            return;
        }

        event.preventDefault();

        const delta =
            event.deltaY ||
            -event.wheelDelta ||
            0;

        if (delta === 0) {
            return;
        }

        virtualScroll += delta;

        virtualScroll = Math.max(
            0,
            Math.min(
                virtualScroll,
                maxVirtualScroll
            )
        );

        updateLayout();

        /*
         * Erst nach dem zusätzlichen Scrollweg wird
         * die Seite wieder freigegeben.
         */
        if (
            virtualScroll >= maxVirtualScroll &&
            delta > 0
        ) {
            unlockScroll('down');
        }

        if (
            virtualScroll <= 0 &&
            delta < 0
        ) {
            unlockScroll('up');
        }
    }

    function onTouchStart(event) {
        if (isMobile()) {
            return;
        }

        if (
            event.touches &&
            event.touches.length > 0
        ) {
            touchStartY =
                event.touches[0].clientY;
        }
    }

    function onTouchMove(event) {
        if (isMobile()) {
            return;
        }

        if (touchStartY === null) {
            return;
        }

        if (
            !event.touches ||
            event.touches.length === 0
        ) {
            return;
        }

        event.preventDefault();

        const currentY =
            event.touches[0].clientY;

        const deltaY =
            touchStartY - currentY;

        onWheel({
            deltaY: deltaY,
            preventDefault: function () {}
        });

        touchStartY = currentY;
    }

    function onTouchEnd() {
        touchStartY = null;
    }

    function updateLayout() {
        if (isMobile()) {
            return;
        }

        /*
         * Der Wrapper bewegt sich höchstens bis zur Position,
         * an der das letzte Item mittig steht.
         *
         * Während der zusätzlichen Haltephase steigt
         * virtualScroll weiter, der Wrapper bleibt aber stehen.
         */
        const visibleScroll = Math.min(
            virtualScroll,
            contentMaxVirtualScroll
        );

        wrapper.style.transform =
            'translateY(' +
            -visibleScroll +
            'px)';

        updateItemsOpacity(visibleScroll);
    }

    function updateItemsOpacity(visibleScroll) {
        if (
            !itemsMeta.length ||
            contentHeight === 0
        ) {
            return;
        }

        const visibleCenter =
            visibleScroll +
            contentHeight / 2;

        const maxDistance =
            contentHeight / 2;

        itemsMeta.forEach(function (meta) {
            const itemCenter =
                meta.top +
                meta.height / 2;

            const distance = Math.abs(
                itemCenter - visibleCenter
            );

            let opacity =
                1 -
                distance / maxDistance;

            if (opacity < 0) {
                opacity = 0;
            }

            if (opacity > 1) {
                opacity = 1;
            }

            meta.el.style.opacity =
                String(opacity);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            init
        );
    } else {
        init();
    }
})();
